<template>
  <md-dialog
    :id="refName"
    :ref="refName"
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="loading modals"
  >
    <md-dialog-title>
      <div class="standard-modal__title">
        {{ title }}
      </div>
    </md-dialog-title>

    <md-dialog-content>
      <div class="standard-modal__description">
        <slot />
        <loading />
      </div>

      <attention-box
        v-if="warningEnabled"
        width="full-size"
      >
        <span v-html="warningText" />
        <span
          v-if="warningAction"
          class="hyper-link"
          @click="warningEvent()"
        >{{ warningAction }}</span>.
      </attention-box>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import mixin from './../modalMixin'

export default {
  name: 'ModalLoading',
  mixins: [mixin]
}
</script>

<style lang="scss">
.loading.modals .md-dialog {
  min-width: 470px;
  min-height: 130px;
  border-radius: 7px;

  p {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0.2px;
    text-align: center;
    color: #303030;
    margin-bottom: 1em;
    font-family: Roboto, sans-serif;
  }
}
</style>
